<template>
  <div>
    <template v-if="classList">
      <button v-if="displayType === 'dropdown-item'" @click="updateClassListOrderClicked" class="text-gray-900 group flex w-full items-center px-2 py-2 text-gray-800 hover:bg-gray-200">
         <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 w-5 h-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z" />
        </svg>
        Edit Division Order
      </button>
      <button v-else @click="updateClassListOrderClicked" class="btn-sm btn-blue-outline">Edit Division Order</button>
    </template>
    <b-modal ref="divisionOrder" title="Show" no-close-on-backdrop>
      <div class="text-left">
        <p class="text-xl">Divisions</p>
        <p class="text-sm text-gray-800">Drag and drop to update the order of the divisions for this show</p>
        <hr class="mt-2"/>
        <ul class="">
          <draggable v-model="showDivisionGroups" group="market" @start="drag=true" @end="drag=false" handle=".handle">
            <li v-for="(dg,i) in showDivisionGroups" :key="i" class="flex p-2 border-b items-center hover:bg-gray-200">
              <div  class="text-xl handle draggable mr-3">&#9776;</div>
              {{dg.division}}
            </li>
          </draggable>
        </ul>
      </div>
      <div slot="modal-footer" class="w-full">
        <div class="flex justify-end">
          <button v-if="showBook" class="btn-green btn-sm mr-2" variant="primary" @click="saveNewShowBookOrder">
            Save Show Book Order
          </button>
          <button v-if="classList" class="btn-green btn-sm mr-2" variant="primary" @click="saveNewClassListOrder">
            Save Class List Order
          </button>
          <button class="btn-red-outline btn-sm" variant="primary" @click="$refs.divisionOrder.hide()">
            Cancel
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  props: {
    showBook: {
      default: null,
      type: Object
    },
    classList: {
      default: null,
      type: Array
    },
    displayType: String
  },
  data () {
    return {
      divisions: [],
      showDivisionGroups: []
    }
  },
  methods: {
    updateClassListOrderClicked () {
      let list = []
      this.showDivisionGroups = []
      let currentGroup = null
      let currentDivision = ''

      this.classList.forEach((c, i) => {
        // Filter out sub-division from sorting, they are just there to preserve winners.
        if (c.is_sub_division) {
          return
        }
        let divisionName = c.division
        if (divisionName === 'Overall') {
          divisionName = c.class_name ? c.class_name : c.className
        }

        if (list.indexOf(divisionName) === -1 || (currentDivision !== divisionName)) {
          list.push(divisionName)
          if (currentGroup) {
            this.showDivisionGroups.push(currentGroup)
          }
          currentDivision = divisionName
          currentGroup = {
            division: divisionName,
            classes: [c]
          }
        } else {
          currentGroup.classes.push(c)
        }
      })
      // Add the last group to the class list
      if (currentGroup) {
        this.showDivisionGroups.push(currentGroup)
      }
      this.divisions = list

      this.$refs.divisionOrder.show()
    },
    saveNewClassListOrder () {
      let newClassList = []
      this.showDivisionGroups.forEach(dg => {
        dg.classes.forEach(c => {
          newClassList.push(c)
        })
      })
      this.$emit('updateClassList', newClassList, this.showDivisionGroups)
      this.$refs.divisionOrder.hide()
    }
  },
  computed: {
  }
}
</script>

<style>

</style>
